import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '../services/permission.service';
import { APP_ROUTES } from '../constants/routes.constants';
import { Permission } from '../constants/permissions.constants';

type PermissionInput = Permission | readonly Permission[];

export const permissionGuard = (permission: PermissionInput, mode: 'any' | 'all' = 'any'): CanActivateFn => {
  return () => {
    const permissionService = inject(PermissionService);
    const router = inject(Router);

    const list = Array.isArray(permission) ? permission : [permission];
    const allowed =
      mode === 'all'
        ? permissionService.hasAllPermissions(list)
        : permissionService.hasAnyPermission(list);

    if (allowed) {
      return true;
    }

    return router.createUrlTree([APP_ROUTES.FORBIDDEN]);
  };
};
